<template>
  <b-modal ref="modal-respuesta" centered body-class="mb-5 pb-4" hide-footer>
    <!--HEADER MODAL -->
    <template v-slot:modal-header>
      <div class="row ml-0">
        <!-- logo mineduc-->
        <div class="logo col-3 pl-0 mt-n3">
          <a href="https://www.mineduc.cl/" target="_blank">
            <img
              class="img-fluid pr-lg-4"
              src="@/assets/img/logo-tope-subesup-mineduc3.png"
              alt="Ministerio de Educación"
            />
          </a>
        </div>

        <!--<div class="col-12 offset-4 mt-n3 pl-3">
          <a href="landing-v4.html">
            <img
              src="@/assets/img/logo_acceso.svg"
              class="logo-acceso img-fluid w-25"
              alt="logo ACCESO a la Educación Superior"
            />
          </a>
        </div>-->
      </div>

      <button type="button" class="close" @click="hideModal">
        <span aria-hidden="true">×</span>
      </button>
    </template>
    <!--BODY MODAL -->
    <img v-if="respuestaContacto"
      class="img-fluid pr-lg-4"
      src="@/assets/img/simulacion-enviada.gif"
      alt="Simulación enviada"
    />
     <img v-else
      class="img-fluid pr-lg-4"
      src="@/assets/img/datos-enviados.gif"
      alt="Datos Enviados"
    />
  </b-modal>
</template>

<script>
export default {
  name: "RespuestaEnvio",
  props: {
    respuestaContacto: { type: Boolean }
  },
  data() {
    return {};
  },
  methods: {
    showModal() {
      this.$refs["modal-respuesta"].show();
    },
    hideModal() {
      this.$refs["modal-respuesta"].hide();
    }
  }
};
</script>

<style>
</style>


// WEBPACK FOOTER //
// src/components/generales/modales/RespuestaEnvio.vue